import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { faDownload, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CloseOrderButton from 'src/components/ReportViewer/OrderTasks/CloseOrderButton';

import { I18NextNS } from 'src/models/Language.model';

interface CustomModalFooterProps {
  handleDownloadReport: () => void;
  handlePrintReport: () => void;
  handleCloseReportViewer: () => void;
  handleRefreshOrders: () => void;
  blobData: Blob | undefined;
}

export default function CustomModalFooter({
  handleDownloadReport,
  handlePrintReport,
  handleCloseReportViewer,
  handleRefreshOrders,
  blobData,
}: CustomModalFooterProps) {
  const { t } = useTranslation(I18NextNS.COMMON);

  return (
    <Modal.Footer className="d-flex w-100 justify-content-between">
      <div className="d-flex gap-2 justify-content-start">
        <Button
          variant="primary-100"
          onClick={handleDownloadReport}
          data-test="download-btn"
          disabled={!blobData}
          data-track="results.report-viewer.download-report"
          data-observe
        >
          <FontAwesomeIcon icon={faDownload} className="me-1"></FontAwesomeIcon>
          {t('report.downloadReport')}
        </Button>

        <Button
          variant="primary-100"
          onClick={handlePrintReport}
          disabled={!blobData}
          data-track="results.report-viewer.print-report"
          data-observe
        >
          <FontAwesomeIcon icon={faPrint} className="me-1"></FontAwesomeIcon>
          {t('report.printReport')}
        </Button>
      </div>
      <div className="d-flex gap-2 justify-content-end">
        <CloseOrderButton
          onOrderComplete={() => {
            handleCloseReportViewer();
            handleRefreshOrders();
          }}
        />
      </div>
    </Modal.Footer>
  );
}
